export function selectNode (selector, rootElement = document) {
  return rootElement.getElementsByClassName(selector)[0];
}

export function selectAllNodes (selector, rootElement = document) {
  return [...rootElement.getElementsByClassName(selector)];
}